const BGCOLORS = {
  default: 'var(--kmx-mui-palette-secondary-faint)',
  preApproved: 'var(--kmx-mui-palette-success-faint)',
  additionalDown: 'var(--kmx-mui-palette-warning-faint)',
  noInfo: 'var(--kmx-mui-palette-secondary-faint)',
  declined: 'var(--kmx-mui-palette-error-faint)',
  notNeeded: 'var(--kmx-mui-palette-primary-faint)',
  disabled: 'var(--kmx-mui-palette-secondary-faint)',
};

const TEXTCOLORS = {
  default: 'var(--kmx-mui-palette-text-secondary)',
  preApproved: 'var(--kmx-mui-palette-success-main)',
  additionalDown: 'var(--kmx-mui-palette-warning-main)',
  noInfo: 'var(--kmx-mui-palette-text-secondary)',
  declined: 'var(--kmx-mui-palette-error-main)',
  notNeeded: 'var(--kmx-mui-palette-primary-main)',
  disabled: 'var(--kmx-mui-palette-text-secondary)',
};

export { BGCOLORS, TEXTCOLORS };
